import { gql } from '@apollo/client';
import GSS_STUDENT_SETTINGS_FRAGMENT from '../../fragments/gss-student-settings';

const GET_GSS_STUDENT_SETTINGS = gql`
  query gssStudentSettings($where: PliStudentSettingsWhereInput!) {
    gssStudentSettings(where: $where) {
      ...BaseGssStudentSettings
    }
  }
  ${GSS_STUDENT_SETTINGS_FRAGMENT}
`;

export default GET_GSS_STUDENT_SETTINGS;
